import {MAX_ACCOUNTS_FREE, MAX_ACCOUNTS_PREMIUM} from '@lib/accounts/constants';
import {
  MessarioLaunchSlot,
  MessarioLaunchSlotResolution
} from '@lib/messarioLaunch/types';

export function resolveMessarioLaunchSlot(
  slots: MessarioLaunchSlot[],
  expectedUserId: string,
  hasSomeonePremium: boolean
): MessarioLaunchSlotResolution {
  const found = slots.find(({userId}) => userId === expectedUserId);
  if(found) {
    return {kind: 'found', slot: found.slot};
  }

  const maxAccounts = hasSomeonePremium ? MAX_ACCOUNTS_PREMIUM : MAX_ACCOUNTS_FREE;
  const empty = slots
    .filter(({slot, userId}) => slot <= maxAccounts && !userId)
    .sort((a, b) => a.slot - b.slot)[0];

  return empty ? {kind: 'empty', slot: empty.slot} : {kind: 'full'};
}

export function compareMessarioLaunchUser(
  expectedUserId: string,
  actualUserId: string
): 'match' | 'mismatch' {
  return expectedUserId === actualUserId ? 'match' : 'mismatch';
}
